import SvgLogoPrimary from './svgs/LogoPrimary.js';
import SvgLogoSecondary from './svgs/LogoSecondary.js';
import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import { useIcon } from '../../shared-components/icon/index.js';

var logo = (props => useIcon(SvgLogoPrimary, SvgLogoSecondary, props));

export { logo as default };
